module.exports = __webpack_public_path__ + "images/fa-js2025-bg-site-pricing-mobile.webp";